import { useCurrentShopSuspense } from "@/api/shops/use-current-shop-suspense";
import useDeleteShopView from "@babackapp/private-api-client/client/use-delete-shop-view";
import { ShopViewDto } from "@babackapp/private-api-client/types";
import useTranslation from "@babackapp/translations/use-translation";
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogTrigger,
} from "@babackapp/ui/components/alert-dialog";
import { PropsWithChildren, useCallback } from "react";

type ConfirmDialogProps = {
  shopView: ShopViewDto;
  disabled?: boolean;
  onDelete?: () => void;
};

export default function DeleteShopViewConfirmDialog({
  children,
  shopView,
  disabled,
  onDelete,
}: PropsWithChildren<ConfirmDialogProps>) {
  const t = useTranslation();
  const { data: shop } = useCurrentShopSuspense();
  const { mutateAsync: removeMutation } = useDeleteShopView(
    shop.id,
    shopView.id,
  );

  const remove = useCallback(async () => {
    await removeMutation();
    onDelete?.();
  }, [onDelete, removeMutation]);

  return (
    <AlertDialog>
      <AlertDialogTrigger disabled={disabled}>{children}</AlertDialogTrigger>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle> {t("misc.areYouSure")}</AlertDialogTitle>
          <AlertDialogDescription>
            {t("settings.shop.confirmDelete.description")}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel> {t("misc.cancel")}</AlertDialogCancel>
          <AlertDialogAction onClick={remove}>
            {" "}
            {t("misc.confirm")}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
